import { render, staticRenderFns } from "./SavingDialog.vue?vue&type=template&id=0aa8cee4&"
import script from "./SavingDialog.vue?vue&type=script&lang=ts&"
export * from "./SavingDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports